import {
  parseValidations,
  parseValidationSetup,
  setValidationRule,
  ValidationMixins,
  Validators
} from '../../../../../lib/validations'
const {required, helpers} = Validators

import LanguageMixin from '../../../../../mixins/lang'
import SettingsMixin from '../../../../../mixins/settings'

const EventBus = window.VueEventBus

const validations = {
  number: setValidationRule('fields.number', {
    required: {error: 'Card number is required.'},
    digits: {error: 'Card number is required.', rule: helpers.regex('digits', /^[0-9]*$/)}
  }),
  cvv: setValidationRule('fields.cvv', {
    required: {error: 'Card code is required.'},
    digits: {error: 'Card code is required.', rule: helpers.regex('digits', /^[0-9]*$/)}
  }),
}

export default {
  translations: {},
  settings: {},
  name: 're-add-card',
  props: {
    translations: {},
    settings: {},
    classes: {
      type: [String, Array, Object],
      default: null
    },
    title: {
      type: String,
      default: 'Add Card'
    },
    showTitle: {
      type: [Boolean, Number, String],
      default: true
    },

    errorMessage: {
      type: String,
      default: null,
    },
    addingMessage: { //@added:not-implemented
      type: String,
      default: null,
    },

    numberLabel: {
      type: String,
      default: 'Card Number'
    },
    numberPlaceholder: {
      type: String,
      default: 'XXXX XXXX XXXX XXXX'
    },
    numberClasses: {
      type: [String, Array, Object],
      default: 'form-control'
    },
    codeLabel: {
      type: String,
      default: 'Code'
    },
    codePlaceholder: {
      type: String,
      default: '****'
    },
    codeClasses: {
      type: [String, Array, Object],
      default: 'form-control'
    },

    buttonTitle: {
      type: String,
      default: 'Add Card'
    },
    buttonClasses: {
      type: [String, Array, Object],
      default: null,
    },
    showCancelButton: {
      type: [Boolean, Number, String],
      default: true,
    },
    cancelButtonTitle: {
      type: String,
      default: "Cancel",
    },
    cancelButtonClasses: {
      type: [String, Array, Object],
      default: null,
    },

    isProcessing: {
      type: Boolean,
      default: null,
    },
    hasResendCode: {
      type: Boolean,
      default: null,
    },
    resendCodeMessage: {
      type: String,
      default: 'Did you forget the Card code?',
    },
    resendCodeLinkLabel: {
      type: String,
      default: 'Resend code'
    },
    hasHelpNumberLink: {
      type: Boolean,
      default: true
    },
    helpNumberLinkLabel: {
      type: String,
      default: 'What is this?'
    },
    hasHelpCodeLink: {
      type: Boolean,
      default: true
    },
    helpCodeLinkLabel: {
      type: String,
      default: 'What is this?'
    },
  },

  mixins: [ValidationMixins, SettingsMixin, LanguageMixin],

  data() {
    return {
      fields: {
        number: null,
        cvv: null,
      },
      processing: false,
      validations: parseValidationSetup(validations, this),
    }
  },
  validations:  { fields: parseValidations(validations) },

  watch: {
    isProcessing(val) {
      this.processing = val
    }
  },

  created() {
    this.$v.$reset()
    this.processing = this.isProcessing
    this.fields.number = null
    this.fields.cvv = null
  },

  computed: {
    isRequestError() {
      return !_.isEmpty(this.errorMessage)
    },
  },

  methods: {
    getFieldClass(field) {
      const def = this.$$s('form.fields.' + field, this.$$s('component.addCard.form.fields.' + field, {}))
      return [def.class || null, def.required !== false ? 'required' : null]
    },
    addCard() {
      EventBus.$emit('card.before.add')
      this.formSubmitting = true
      this.$v.$touch()
      if (!this.isAnyInvalid) {
        this.processing = true
        this.$emit('card-add', this.fields)
        EventBus.$emit('card.add', this.fields)
      }
    },
    cancelThis() {
      this.$v.$reset()
      this.formSubmitting = false
      this.$emit('close')
      EventBus.$emit('card.add.cancel')
    },
    resendCode() {
      this.$emit('card-open-resend-code')
      EventBus.$emit('card.open.resend.code')
    },
    whatIsCode() {
      this.$emit('card-open-info-code')
      EventBus.$emit('card.open.info.code')
    },
    whatIsNumber() {
      this.$emit('card-open-info-number')
      EventBus.$emit('card.open.info.number')
    }
  },
}
